export default "__VITE_ASSET__Dva$ZPTA__"